import usePosOrderCurrentAction from "@/shared/atoms/usePosOrderCurrentAction";
import { DeliveryMethods } from "@/shared/utils/enum";
import {
  defaultPosOrderDeliveryCost,
  usePosOrderDeliveryCost,
} from "@/shared/atoms/usePosOrderDeliveryCostAtom";
import usePosOrderDeliveryMethod from "@/shared/atoms/usePosOrderDeliveryMethodAtom";
import useActionClick from "./useActionClick";
import PosMenuBottomActionButton, {
  PosMenuAction,
} from "../PosMenu/PosMenuBottomActionButton";
import { useTranslation } from "react-i18next";
import { CurrentActionTypes } from "@/shared/atoms/usePosOrderCurrentAction";

const useDeliveryCostAction = (): PosMenuAction => {
  const { t } = useTranslation();
  const [deliveryCost, setDeliveryCost] = usePosOrderDeliveryCost();
  const [deliveryMethod] = usePosOrderDeliveryMethod();

  return {
    name: "deliveryCost" as CurrentActionTypes,
    label: t("posOrders.deliveryFee"),
    set: setDeliveryCost,
    deleteAction: () => setDeliveryCost(defaultPosOrderDeliveryCost),
    hasDeleteAction: Number(deliveryCost) > 0,
    filtered: false,
    disabled: deliveryMethod === DeliveryMethods.DINE_IN,
    iconVariant:"truck",
  };
};

const DeliveryCostAction = () => {
  const [currentAction] = usePosOrderCurrentAction();
  const action = useDeliveryCostAction();
  const handleClick = useActionClick(action);

  return (
    <PosMenuBottomActionButton
      action={action}
      isSelected={currentAction?.name === action.name}
      onClick={handleClick}
    />
  );
};

export default DeliveryCostAction;
